import _ from 'lodash';
import classnames from 'classnames';
import createReactClass from 'create-react-class';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Table, Column, Cell } from 'fixed-data-table-2';

import PageLayout from 'components/page_layout';
import SortControl, { SORT_PARAMETERS, getNextSortOrder } from './sort_control';

export const MIN_CELL_WIDTH = 220;
export const CELL_HEIGHT = 50;
export const CELL_PADDING = 8;
export const HEADER_HEIGHT = 38;

const ReportTable = createReactClass({
  propTypes: {
    columns: PropTypes.array,
    rowsCount: PropTypes.number,
    windowWidth: PropTypes.number,
    changeSort: PropTypes.func,
    currentSort: PropTypes.object,
  },

  statics: {
    MIN_CELL_WIDTH,
    CELL_HEIGHT,
    CELL_PADDING,
    SORT_PARAMETERS,
    getNextSortOrder,
  },

  componentDidMount() {
    let reportTable = ReactDOM.findDOMNode(this.refs.reportTable);
    this.setState({ headerPosition: reportTable.getBoundingClientRect().top, fixedHeader: false });
    window.addEventListener('scroll', this.onScroll);
  },

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  },

  getInitialState() {
    return {
      windowHeight: window.innerHeight,
    };
  },

  getDefaultProps() {
    return {
      windowWidth: document.documentElement.clientWidth,
    };
  },

  /* render */
  render() {
    let cols = this.props.columns.map(this.renderColumn);

    let classes = classnames('reportTable', { 'reportTable-fixedHeader': this.state.fixedHeader });
    return (
      <div className={classes} ref="reportTable">
        <Table
          headerHeight={HEADER_HEIGHT}
          maxHeight={CELL_HEIGHT * (this.props.rowsCount + 2)}
          rowHeight={CELL_HEIGHT}
          rowsCount={this.props.rowsCount}
          width={_.max([this.props.windowWidth, /* minWidth= */ 1024])}
        >
          {cols}
        </Table>
      </div>
    );
  },

  renderColumn(column, columnIndex) {
    return (
      <Column
        key={column.header}
        cell={props => this.renderRowElement(column, props, columnIndex)}
        header={this.renderHeaderCell(column, columnIndex)}
        width={column.width || MIN_CELL_WIDTH}
        fixed={columnIndex === 0}
        flexGrow={1}
      />
    );
  },

  renderRowElement(column, props, columnIndex) {
    let classes = classnames('reportTable-cell', {
      'reportTable-cell-left': columnIndex === 0,
      'reportTable-cell-noPadding': column.noPadding,
    });
    return <Cell className={classes}>{column.renderCell(props)}</Cell>;
  },

  renderHeaderCell(column, columnIndex) {
    const sortable = !column.unsortable;
    const currentSort = this.props.currentSort[column.ref];
    let classes = classnames('reportTable-headerCell', {
      'reportTable-headerCell-filtered': sortable && currentSort,
      'reportTable-cell-left': columnIndex === 0,
    });

    return (
      <Cell className={classes} onClick={() => sortable && this.props.changeSort(column.ref)}>
        {column.header}
        {sortable && <SortControl currentSort={currentSort} />}
      </Cell>
    );
  },

  onScroll(e) {
    if (window.pageYOffset + PageLayout.TOP_BAR_HEIGHT >= this.state.headerPosition) {
      if (!this.state.fixedHeader) {
        this.setState({ fixedHeader: true });
      }
    } else {
      if (this.state.fixedHeader) {
        this.setState({ fixedHeader: false });
      }
    }
  },
});

export default ReportTable;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/reporting/report/lib/report_table.jsx